import { CSVLink } from "react-csv"
import { useHistory } from "react-router"

export function LightButton(props: {label: String, onClick?: any, alternate?: boolean, className?: string, fontClasses?: string, id?: string}): JSX.Element {
    var isAlternate = props.alternate? props.alternate : false

    return <>
        <div 
            id={props.id ? props.id : ""}
            className={"font-roboto border border-solid"+
            " not-italic text-center uppercase  cursor-pointer "+
            " tracking-wider py-2 w-fit "+
            (props.fontClasses ? props.fontClasses : "  text-sm ")+
            (isAlternate ? " text-tertiary border-tertiary hover:bg-background hover:text-primary hover:border-primary " : 
                " border-primary text-primary hover:bg-primary hover:text-tertiary ")+
            (props.className ? props.className : "")}
            onClick={props.onClick}>{props.label}</div>
    </>
}

export function DexxButton(props: {label: String, onClick?: any, color1?: string, color2?: string,
        color3?: string, color4?: string, borderColor?: string, className?: string, fontClasses?: string, noBorder?: boolean, 
        noHoverOnSelected?: boolean, noCursor?: boolean, id?: string}): JSX.Element {
    const c1 = props.color1 ? props.color1 : "white"
    const c2 = props.color2 ? props.color2 : "white"
    const c3 = props.color3 ? props.color3 : "white_lighter"
    const c4 = props.color4 ? props.color4 : c1
    const bc = props.borderColor ? props.borderColor : c2
    return <>
        <div className={" font-roboto shadow-xl shadow-black/50 "+
            (props.className ? props.className+" " : " ")+
            (props.noBorder ? " " : " border border-solid  border-"+bc+" ")+
            " not-italic text-center uppercase cursor-"+
            (props.noCursor ? "default " : "pointer ")+
            " tracking-wider py-2 "+
            (props.fontClasses ? props.fontClasses : "  text-xs lg:text-sm ")+
            " text-"+c2+" "+
            (props.noHoverOnSelected ? " " : " hover:bg-"+c3+" hover:text-"+c4+
            " hover:border-"+c4+" ")}
            onClick={props.onClick}
            id={props.id}>{props.label}</div>
    </>
}

export function DexxMaxButton(props: {label: String, onClick?: any, color1?: string, color2?: string,
    className?: string, fontClasses?: string, noBorder?: boolean, 
    noHoverOnSelected?: boolean}): JSX.Element {
    
    let c1 = props.color1 ? props.color1 : "greenMax"
    let c2 = props.color2 ? props.color2 : "white"

return <>
    <div className={" font-roboto  border border-solid  border-"+c2+
        " not-italic text-center uppercase  cursor-pointer "+
        " tracking-wider py-1 w-fit text-xs "+
        " text-"+c2+ " hover:bg-"+c2+"_lightest hover:text-"+c1+
        " hover:border-"+c1+" "+
        (props.className ? props.className : "")}
        onClick={props.onClick}>{props.label}</div>
</>
}

export function BackButton(props: {previousPage?: string, className?: string}): JSX.Element {
    let history = useHistory()
    return <DexxButton label={"Back"} onClick={() => {
            props.previousPage ? 
                history.push(props.previousPage) : 
                history.goBack()}
        }
        className={props.className ? 
            props.className : 
            " rounded-lg px-10 "}
        color3="white_lighter" color1="white" color2="white"/>
}

export function CSVDownloadButton(props: {fileName: string, headers: any[], table: any[]}): JSX.Element {
    return <>
        <CSVLink className="border-solid py-1 md:py-2 px-5 border-dark_blue rounded-lg uppercase 
                text-dark_blue text-xs md:text-sm my-2 ml-8 md:ml-16 hover:bg-primary_lightest
                w-fit align-middle  border-1" 
                filename={props.fileName} headers={props.headers} 
                data={props.table}>Download CSV </CSVLink>
    </>
}

export function BuySellButton(props: {inactive: boolean, label: string, onClick?: Function}): JSX.Element {
    const inactive = props.inactive
    return <>
        <DexxButton label={props.label} color1="succ2" color2="succ2" color3="succ2_lightest"
            noCursor={inactive} noHoverOnSelected={inactive}  onClick={props.onClick}
            className={"rounded-lg px-6 md:px-16 font-bold md:text-xl " + (inactive ? "opacity-50 ": "")} />
    </>
}